<td class="country-cell">
  <app-autosuggest-dropdown-input #countrySelect [options]="countryList" [parentForm]="form" controlName="country" (selectValueChanged)="countryUpdated.emit($event)"></app-autosuggest-dropdown-input>
</td>
<td class="culture-cell"><app-dropdown-input placeholder="All" [options]="cultures" [selectedValue]="contact.culture" (selectValueChanged)="cultureUpdated.emit($event)"></app-dropdown-input></td>
<td class="label-cell"><input type="text" class="form-control" (keyup)="labelUpdated.emit(inputValue($event))" [value]="contact.label"></td>
<td><input type="text" class="form-control" (keyup)="contactUpdated.emit(inputValue($event))" [value]="contact.contact"></td>
<td>
  <app-button
    text="Remove"
    (clicked)="removed.emit()"
    variant="info"
    [visible]="authService.hasPermission(Permissions.TrialSupportContactsDelete)" />
</td>
